import EditorViewState from '../store/schema/EditorViewState';

export default function createEditorViewState(
    content: string = null,
    isDirty: boolean = false
): EditorViewState {
    return {
        content: content,
        isDirty: isDirty,
    };
}
